import { render, staticRenderFns } from "./levelswitch.vue?vue&type=template&id=0921b3bf&scoped=true"
import script from "./levelswitch.vue?vue&type=script&lang=js"
export * from "./levelswitch.vue?vue&type=script&lang=js"
import style0 from "./levelswitch.vue?vue&type=style&index=0&id=0921b3bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0921b3bf",
  null
  
)

export default component.exports